import { getMethod, postMethod, patchMethod } from '../../api/methods'
import API_ROUTES from '../../api/routes'

const {
  SHARE_REPORT,
  UPDATE_REPORT,
  REFRIGERANT_LIST,
  JOBS_UPDATE,
  ADD_ERROR_CODE,
  GET_JOB_LIST,
  SEARCH_JOB_LIST,
  GET_ERROR_CODE,
  SEARCH_ERROR_CODE,
  GET_JOB_DETAILS,
  GET_EQUIPMENT,
  SEARCH_EQUIPMENT,
  GET_REPORT,
  GET_EQUIPMENT_LIST,
  ADD_EQUIPMENT,
  EIN_VALIDATE,
} = API_ROUTES

const getJobListApi = async ({ params }) => {
  const response = await getMethod(GET_JOB_LIST({ params }))
  return response?.data
}

const searchJobListApi = async ({ params }) => {
  const response = await getMethod(SEARCH_JOB_LIST({ params }))
  return response?.data
}

const getErrorCodeApi = async ({ pageNo, params }) => {
  const response = await getMethod(GET_ERROR_CODE({ pageNo, params }))
  return response?.data
}
const searchErrorCodeApi = async ({ pageNo, params }) => {
  const response = await getMethod(SEARCH_ERROR_CODE({ pageNo, params }))
  return response?.data
}

const addErrorCodeApi = async ({ payload }) => {
  const response = await postMethod(ADD_ERROR_CODE, payload)
  return response?.data
}

const editErrorCodeApi = async ({ payload }) => {
  const response = await patchMethod(ADD_ERROR_CODE, payload)
  return response?.data
}

const getJobDetailApi = async ({ params }) => {
  const response = await getMethod(GET_JOB_DETAILS({ params }))
  return response?.data
}

const repairJobApi = async ({ payload }) => {
  const response = await postMethod(JOBS_UPDATE, payload)
  return response
}
const repairJobPatchApi = async ({ payload }) => {
  const response = await patchMethod(JOBS_UPDATE, payload)
  return response
}

const getEquipmentApi = async ({ params }) => {
  const response = await getMethod(GET_EQUIPMENT({ params }))
  return response?.data
}

const searchEquipmentApi = async ({ params }) => {
  const response = await getMethod(SEARCH_EQUIPMENT({ params }))
  return response?.data
}

const getReportApi = async ({ jobId, jobType }) => {
  const response = await getMethod(GET_REPORT({ jobId, jobType }))
  return response?.data
}

const shareCertificateApi = async ({ payload }) => {
  const response = await postMethod(SHARE_REPORT, payload)
  return response
}

const updateReportApi = async ({ payload }) => {
  const response = await postMethod(UPDATE_REPORT, payload)
  return response?.data
}

const getRefrigerantTypeApi = async () => {
  const response = await getMethod(REFRIGERANT_LIST)
  return response?.data
}

const getEquipmentListApi = async ({ params }) => {
  const response = await getMethod(GET_EQUIPMENT_LIST({ params }))
  return response?.data
}

const addEquipmentApi = async ({ payload }) => {
  const response = await postMethod(ADD_EQUIPMENT, payload)
  return response?.data
}

const editEquipmentApi = async ({ payload }) => {
  const response = await patchMethod(ADD_EQUIPMENT, payload)
  return response?.data
}

const einValidationApi = async ({ params }) => {
  const response = await getMethod(EIN_VALIDATE({ params }), {
    hideErrorPopup: true,
  })
  return response?.data
}

export {
  getJobListApi,
  searchJobListApi,
  getJobDetailApi,
  getErrorCodeApi,
  addErrorCodeApi,
  editErrorCodeApi,
  repairJobApi,
  repairJobPatchApi,
  getEquipmentApi,
  searchEquipmentApi,
  getReportApi,
  shareCertificateApi,
  updateReportApi,
  getRefrigerantTypeApi,
  searchErrorCodeApi,
  getEquipmentListApi,
  addEquipmentApi,
  editEquipmentApi,
  einValidationApi,
}
